// this file is copied from backend
// https://github.com/Lyearn/LyearnModules_v2/blob/a04b878989c155082e12c8fb99f4b9bf81d732d0/packages/lyearn-prosemirror-utils/src/utils/prosemirrorDocumentDuration.util.ts
// we are not directly using "@lyearn/prosemirror-utils" because it depends on legacy gprc whose prebuild(during install) is slow and requires and dependency on host machine

import { Node as ProseMirrorDocument } from 'prosemirror-model';

enum BlockTypeEnum {
  LESSON = 'ly__lesson',
  AUDIO = 'audio',
  VIDEO = 'video',
  EMBED = 'embed',
  EXERCISE = 'ly__exercise',
  QUIZ = 'ly__quiz',
  SCORM = 'ly__scorm',
}

const BLOCK_HAS_DURATION_IN_ATTRIBUTE: any = {
  [BlockTypeEnum.AUDIO]: true,
  [BlockTypeEnum.VIDEO]: true,
  [BlockTypeEnum.EXERCISE]: true,
  [BlockTypeEnum.SCORM]: true,
  [BlockTypeEnum.QUIZ]: true,
  [BlockTypeEnum.EMBED]: true,
};

function calculateReadingDurationOfTextContent(textContent: string): number {
  const { length: wordCount } = textContent.split(' ');
  // Human read time is roughly around 265 WPM
  return Math.max(Math.round((wordCount * 60) / 256), 1);
}

function getBlockDurationFromAttributes(attributes: any): number {
  const { duration } = attributes;
  return duration || 0;
}

export function getProseMirrorDocumentDuration({
  proseMirrorDocument,
}: {
  proseMirrorDocument: ProseMirrorDocument;
}): number {
  let duration = 0;
  const {
    type: { name: blockType },
    attrs,
    attrs: { customDuration },
    textContent,
  } = proseMirrorDocument;
  if (customDuration && customDuration > 0) {
    return customDuration;
  }
  for (let index = 0; index < proseMirrorDocument.content.childCount; index++) {
    const childNode = proseMirrorDocument.content.child(index);

    if (childNode.isInline) {
      break;
    }
    duration += getProseMirrorDocumentDuration({ proseMirrorDocument: childNode });
  }
  if (proseMirrorDocument.firstChild?.isInline) {
    duration += calculateReadingDurationOfTextContent(textContent);
  } else if (BLOCK_HAS_DURATION_IN_ATTRIBUTE[blockType]) {
    duration += getBlockDurationFromAttributes(attrs);
  } else if (blockType === 'image') {
    duration += 7;
  }

  if (blockType === BlockTypeEnum.LESSON && duration < 60) {
    duration = 60;
  }

  return duration;
}

export function getProseMirrorDocumentMinimumDuration({
  proseMirrorDocument,
}: {
  proseMirrorDocument: ProseMirrorDocument;
}): number {
  let duration = 0;
  const {
    type: { name: blockType },
    attrs,
  } = proseMirrorDocument;

  for (let index = 0; index < proseMirrorDocument.content.childCount; index++) {
    const childNode = proseMirrorDocument.content.child(index);

    if (childNode.isInline) {
      break;
    }
    duration += getProseMirrorDocumentMinimumDuration({ proseMirrorDocument: childNode });
  }

  if (BLOCK_HAS_DURATION_IN_ATTRIBUTE[blockType]) {
    duration += getBlockDurationFromAttributes(attrs);
  }

  return duration;
}
